(function(){
  function toNum(v){
    var n = parseFloat(String(v ?? "").replace(",", "."));
    return isNaN(n) ? 0 : n;
  }

  function escapeRegExp(s){
    return String(s ?? "").replace(/[.*+?^{}$()|[\]\\]/g, "\\$&");
  }

  function safeEval(expr){
    var cleaned = String(expr ?? "").replace(/\s+/g, "");
    if (!/^[0-9+\-*/().]+$/.test(cleaned)) return null;
    try { return Function("return (" + cleaned + ")")(); }
    catch(e){ return null; }
  }

  /* SLIDER */
  function initSliders(root){
    root.querySelectorAll(".tool-slider").forEach(function(box){
      if (box.getAttribute("data-initialized") === "1") return;
      box.setAttribute("data-initialized","1");

      var input = box.querySelector(".tool-slider-input");
      var out = box.querySelector(".tool-slider-value");
      if (!input || !out) return;

      var unit = box.getAttribute("data-unit") || "";
      function update(){
        out.textContent = input.value + (unit ? " " + unit : "");
      }

      input.addEventListener("input", update);
      input.addEventListener("change", update);
      update();
    });
  }

  /* CALCULATOR */
  function initCalculators(root){
    root.querySelectorAll(".tool-calculator").forEach(function(box){
      if (box.getAttribute("data-initialized") === "1") return;
      box.setAttribute("data-initialized","1");

      var inputs = Array.prototype.slice.call(box.querySelectorAll(".tool-calc-input"));
      var out = box.querySelector(".tool-calc-output-value");
      if (!inputs.length || !out) return;

      var formulaRaw = box.getAttribute("data-formula") || "";

      function compute(){
        var expr = formulaRaw;

        inputs.forEach(function(inp){
          var name = inp.getAttribute("data-field") || "";
          if (!name) return;
          var val = toNum(inp.value);
          var re = new RegExp(escapeRegExp(name), "g");
          expr = expr.replace(re, String(val));
        });

        var result = safeEval(expr);
        out.textContent = (result === null || typeof result !== "number" || isNaN(result)) ? "-" : String(result);
      }

      inputs.forEach(function(inp){
        inp.addEventListener("input", compute);
        inp.addEventListener("change", compute);
      });

      compute();
      setTimeout(compute, 60);
    });
  }

  /* CHECKLIST */
  function initChecklists(root){
    root.querySelectorAll(".tool-checklist").forEach(function(box){
      if (box.getAttribute("data-initialized") === "1") return;
      box.setAttribute("data-initialized","1");

      var checks = Array.prototype.slice.call(box.querySelectorAll('input[type="checkbox"]'));
      if (!checks.length) return;

      var doneEl = box.querySelector('[data-checklist="done"], .tool-checklist-done');
      var totalEl = box.querySelector('[data-checklist="total"], .tool-checklist-total');

      function update(){
        var done = checks.filter(function(c){ return c.checked; }).length;
        var total = checks.length;

        if (doneEl) doneEl.textContent = String(done);
        if (totalEl) totalEl.textContent = String(total);

        box.setAttribute("data-done", String(done));
        box.setAttribute("data-total", String(total));
      }

      checks.forEach(function(c){
        c.addEventListener("change", update);
      });

      update();
      setTimeout(update, 60);
    });
  }

  function initAll(root){
    initSliders(root);
    initCalculators(root);
    initChecklists(root);
  }

  function boot(){
    initAll(document);

    var mo = new MutationObserver(function(muts){
      for (var i=0; i<muts.length; i++){
        if (muts[i].addedNodes && muts[i].addedNodes.length){
          initAll(document);
          break;
        }
      }
    });

    mo.observe(document.documentElement, { childList: true, subtree: true });
  }

  if (document.readyState === "loading"){
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }
})();

document.addEventListener("DOMContentLoaded", () => {
  const heroSlot = document.querySelector(".formatted-blog-post-v3 [data-aa-hero-summary]");
  if (!heroSlot) return;

  const summary = document.querySelector(".formatted-blog-post-v3 .summary");
  if (!summary) return;

  heroSlot.appendChild(summary);
});